<template>
    <img :src="getProps(row, item.prop)" :style="item.style" />
</template>

<script>
import { getProps } from '@/lin/utils/util'

export default {
    props: {
        row: {
            type: Object,
            default: () => {},
        },
        item: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        getProps: getProps,
    }
}
</script>

